import { create } from 'zustand';

import { configSlice } from './config';
import { errorSlice } from './error';
import { guidesSlice } from './guides';
import { localStorageSlice } from './localstorage-data';
import { paymentsSlice } from './payments';
import { sessionsSlice } from './sessions';
import { sessionStorageSlice } from './sessionstorage-data';
import { subscriptionsSlice } from './subscriptions';
import { ILocalStorageStore, ISessionStorageStore, StoreType, TConfigStore } from './types';
import { uiSlice } from './ui';
import { unsubscribeSlice } from './unsubscribe';
import { userSlice } from './user';

export const useStore = create<StoreType>((...store) => ({
  ...userSlice(...store),
  ...paymentsSlice(...store),
  ...unsubscribeSlice(...store),
  ...guidesSlice(...store),
  ...sessionsSlice(...store),
  ...errorSlice(...store),
  ...subscriptionsSlice(...store),
  ...uiSlice(...store),
}));

export const useLocalStorageStore = create<ILocalStorageStore>((...store) => ({
  ...localStorageSlice(...store),
}));

export const useSessionStorageStore = create<ISessionStorageStore>((...store) => ({
  ...sessionStorageSlice(...store),
}));

export const useConfigStore = create<TConfigStore>((...store) => ({
  ...configSlice(...store),
}));

export { useArticleViewStore } from './article-view';
export { useInsightsSearchHistoryStore } from './insights-search-history';
